import { calculateHaversineDistance } from "./calculateHaversineDistance";


export function validateUserGeoPosition ({radius, company, user}){
    return new Promise(async (resolve, reject) => {
        try{

            const companyGeoLocation = [company.latitude, company.longitude];
            
            const userGeoLocation = [user.latitude, user.longitude];

            const distance = calculateHaversineDistance(userGeoLocation, companyGeoLocation);

            const validation = distance <= radius ? true : false;

            if(!validation){
                throw new Error({message: 'INVALID GEOLOCATION'});
            }

            return resolve(true);

        } catch (e) {
            console.error('ERROR - VALIDATE USER POSITION FUNCTION:', e);
            reject({status: 401, message: e.message ?? 'GEOLOCATION BLOCKED'});
        }
    })
}